export default __webpack_public_path__ + "static/media/hero-bg3.1853823c.jpg";